import routerOptions0 from "/codebuild/output/src3782319031/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@24.0.0_db0@0.3.2_eslint@8.57.1_ioredis@5._c3105bfba32d21948d08a31c65c5bad5/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}